import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'r2b_referrals-visits_to_landing_page_with_bonus_referral_offer-view';

/**
 * Tracks the views&#x2F;visits to the landing page with bonus referral offer
 */
export function trackR2BReferralsVisitsToLandingPageWithBonusReferralOfferView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
